/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.directives.module.ts" />
/// <reference path="../services/apiservice.ts" />
/// <reference path="../../common/iapirequestconfig.ts" />
/// <reference path="../../common/services/apiservice.ts" />

module App.Common.Directives {
	'use strict';

	class AutoSaveController {
		public autoSaveFormName: string;
		public autoSaveFnName: string;
		public autoSaveFn:() => angular.IPromise<any>;
		public debounce: number = 1500;
		public form: angular.IFormController;
		public timerReference: number;
		public formWatchesCancel: any[] = [];

		public static $inject = ['$scope', '$element', '$attrs'];

		constructor(private $scope: angular.IScope, $element: angular.IAugmentedJQuery, private $attrs: angular.IAttributes) {
			this.autoSaveFormName = $element[0]['name'];
			this.autoSaveFnName = this.$attrs['autoSave'];
			if (!!($attrs['autoSaveDebounce']) && parseInt($attrs['autoSaveDebounce'],10) > 1000) {
				this.debounce = parseInt($attrs['autoSaveDebounce'], 10);
			}

			if ($element[0].tagName.toLowerCase() !== 'form') {
				throw Error('directive auto-save must be applied on tag <form>');
			}
			if (!(!!this.autoSaveFnName)) {
				throw Error('attribute auto-save of such directive must have a value - the name of the saving function');
			}
			//watch the form for changes
			$scope.$watch(this.autoSaveFormName, (newVal: angular.IFormController, oldVal: angular.IFormController) => {
				//remember the updated form
				this.form = newVal;
				//check all fields on the form
				angular.forEach(this.form, function (value: angular.INgModelController, key: string) {
					if (typeof value === 'object' && value.hasOwnProperty('$modelValue')) {
						//define a watch for this field
						$scope.$watch(`${this.autoSaveFormName}.${key}.$dirty`, (newVal, oldVal) => {
							//if the field is dirty
							if (newVal) {
								//get the field
								let element = jQuery(`[name='${key}']`);
								if (!!element && element.length > 0) {
									//check the field is not ignored by auto-save
									if (!element[0].hasAttribute('auto-save-ignore')) {
										//mark this field as pristine so we can monitor an future changes before the form is saved
										$scope.$eval(`${this.autoSaveFormName}.${key}`)['$setPristine']();
										//stop any pending saves
										clearTimeout(this.timerReference);
										//queue a save
										this.timerReference = setTimeout(this.doSave, this.debounce, this);
									}
									else {
										//this field does not trigger auto-save so set the form as pristine
										$scope.$eval(`${this.autoSaveFormName}`)['$setPristine']();
									}
								}
							}
						}, true);

					}
				}, this);
			}, true);
			//get the reference to the auto-save field on the host controller
			this.getAutoSaveFunction();
		}

		/**
		 * Perform a save
		 * @param autoSaveController
		 */
		public doSave(autoSaveController: AutoSaveController): void {
			try {
				//get a reference to the main form
				let element = jQuery(`[name='${autoSaveController.autoSaveFormName}']`);
				if (!!element && element.length > 0) {
					//add a saving message the to document
					let style = 'position:fixed;top:0;right:0;';
					style += 'margin:5px 5px 0 0;';
					style += 'background:#ddd;';
					style += 'padding:2px 5px 2px 5px;';
					style += 'border-radius:5px 5px 5px 5px;';
					element.append(`<div id='autoSaveSaving' style='${style}'>auto saving...</div>`);
				}
				//invoke the save
				autoSaveController.autoSaveFn().then((success:any) => {
					//saved completed
				}).catch((error: any) => {
					console.error('Error in autoSave!');
					console.error(error);
				}).finally(() => {
					//the save has completed - remove the saving message
					jQuery('#autoSaveSaving').remove();
				});
			}
			catch (e) {
				//report the error
				console.error(e);
			}
		}

		/**
		 * Get the auto-save function on the host controller
		 */
		private getAutoSaveFunction(): void {
			//split the supplied function 
			var parts:any[] = this.$attrs['autoSave'].split('.');
			var bindingContext = this.$scope;
			this.autoSaveFn = this.$scope[parts[0]];
			if (parts.length > 1) {
				for (var i = 1, l = parts.length; i < l; i++) {
					this.autoSaveFn = this.autoSaveFn[parts[i]];
					bindingContext = bindingContext[parts[i - 1]];
				}
			}
			if (this.autoSaveFn) {
				this.autoSaveFn = this.autoSaveFn.bind(bindingContext);
			} else {
				console.error('Could not find auto-saving function', this.$attrs['autoSave'], 'on the scope. When specifying the method call, don\'t need to include the parenthesis and make sure it returns an angular.IProimise<any>.');
			}
		}

	}

	export class AutoSaveDirective implements angular.IDirective {
		public restrict = 'A';
		public scope = false;
		public controller = AutoSaveController;
	}

	angular.module('app.common.directives').directive('autoSave', () => { return new AutoSaveDirective(); });
}
